<template>
  <div>
    <SysDialogFullScreen
      v-model="dialog"
      titulo="Vincular Fornecedores com Comprador"
      ocultarAcoes
      @click:hidden-dialog="$emit('fechar-dialog')"
    >
      <PassosFornecedorVsCompradorVue
        :items_tabelas="selects"
        :selected="selected"
        :dialog="dialogMultiplosCompradores"
        @fechar-dialog-multiplos-compradores="fecharDialog()"
      />
    </SysDialogFullScreen>
  </div>
</template>

<script>
import SysDialogFullScreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import PassosFornecedorVsCompradorVue from './PassosFornecedorVsComprador.vue';

export default {
  components: { SysDialogFullScreen, PassosFornecedorVsCompradorVue },
  props: ["dialogMultiplosCompradores", "selected", "selectsFornecedor"],
  data() {
    return {
      dialog: false,
      selects: {
        fornecedores: {
          items: [],
        },
        compradores: {
          items: [],
        },
      },
      editedItem: {
        idcomprador: "",
        idfornecedor: [],
      },
    };
  },
  mounted() {
    this.selects = this.selectsFornecedor;
  },
  watch: {
    selected() {
      this.editedItem.idfornecedor = this.selected;
    },
    dialogMultiplosCompradores() {
      this.dialog = this.dialogMultiplosCompradores;
    },
  },
  methods: {
    fecharDialog() {
      this.dialog = false;
      this.$emit('atualizar-tela-de-fornecedores');
    }
  }
};
</script>

<style>
</style>
